import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {CurrentIds, DeviceStorageState} from '@spout/global-any/models';
import {selectCurrentIdsFromAccountDefaultIds$} from '../../+account/account.selectors';
import {mergePropsIfSourceHasValue} from '@uiux/fn';
import {hasValuePipe} from '@uiux/rxjs';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {getDefaultAudioDevice} from '../../audio/helpers/input-device';
import {SptRecorderService} from '../../audio/spt-recorder.service';
import {DeviceStorageService} from './device-storage.service';

@Injectable()
export class DeviceEntityService {
  constructor(
    private device: DeviceStorageService,
    private store: Store,
    private _recorder: SptRecorderService
  ) {}

  saveCurrentIdsFromAccountDefaultIds(
    storage: Partial<DeviceStorageState>
  ): Observable<Partial<DeviceStorageState>> {
    const _currentIdStorage = {
      ...storage
    };

    // console.log('SAVE CURRENT IDS FROM ACCOUNT DEFAULT IDS', _currentIdStorage);

    return this.store.pipe(
      selectCurrentIdsFromAccountDefaultIds$,
      hasValuePipe<CurrentIds, CurrentIds>(),
      take(1),
      map((currentIds: CurrentIds) => {
        _currentIdStorage.currentIds = {
          ...currentIds
        };

        return _currentIdStorage;
      })
    );
  }

  saveDefaultAudioDevice(
    storage: Partial<DeviceStorageState>
  ): Observable<Partial<DeviceStorageState> | null> {
    return getDefaultAudioDevice().pipe(
      map((deviceInfo: MediaDeviceInfo | null) => {
        if (deviceInfo) {
          const storeData: MediaDeviceInfo = mergePropsIfSourceHasValue(
            {...storage},
            {
              mediaDeviceInfo: deviceInfo.toJSON()
            }
          );

          return storeData;
        }

        return null;
      })
    );
  }
}
